import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import IconVolumeOff from './icons/icon-volume-off'
import IconVolumeOn from './icons/icon-volume-on'
import styles from './control-volume.css'

class ControlVolume extends React.PureComponent {
  render() {
    const {
      wrapperClassName, iconClassName, mute, unmute, isMuted
    } = this.props
    return (
      <div
        className={classnames(wrapperClassName, styles.wrapper)}
        onClick={() => {
          if (isMuted) {
            unmute()
          } else {
            mute()
          }
        }}
      >
        <IconVolumeOff
          className={classnames(iconClassName, {
            [styles.hide]: !isMuted
          })}
        />
        <IconVolumeOn
          className={classnames(iconClassName, {
            [styles.hide]: isMuted
          })}
        />
      </div>
    )
  }
}

ControlVolume.propTypes = {
  iconClassName: PropTypes.string.isRequired,
  wrapperClassName: PropTypes.string.isRequired,
  isMuted: PropTypes.bool,
  mute: PropTypes.func.isRequired,
  unmute: PropTypes.func.isRequired
}

ControlVolume.defaultProps = {
  isMuted: true
}

export default ControlVolume
